import { render, staticRenderFns } from "./Descricao.vue?vue&type=template&id=6afa9426&scoped=true&"
import script from "./Descricao.vue?vue&type=script&lang=js&"
export * from "./Descricao.vue?vue&type=script&lang=js&"
import style0 from "./Descricao.vue?vue&type=style&index=0&id=6afa9426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afa9426",
  null
  
)

export default component.exports